module.exports = __webpack_public_path__ + "static/media/doorhanHand.6a32d45c.jpg";